import { UtensilsCrossed } from "lucide-react";

interface PiktableLoaderProps {
  message?: string;
}

export function PiktableLoader({ message = "Chargement..." }: PiktableLoaderProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      {/* Logo animé */}
      <div className="relative">
        <div className="animate-pulse">
          <UtensilsCrossed className="w-16 h-16 text-primary" />
        </div>
        {/* Cercle animé autour du logo */}
        <div className="absolute inset-0 -m-4">
          <div className="w-24 h-24 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
        </div>
      </div>
      
      {/* Texte Piktable */}
      <h1 className="mt-8 font-playfair text-2xl font-bold text-foreground">
        Piktable
      </h1>
      
      {/* Message de chargement */}
      <p className="mt-2 text-sm text-muted-foreground animate-pulse">
        {message}
      </p>
    </div>
  );
}
